import { render } from "./CadastrarCurso.vue?vue&type=template&id=5c84f97e&scoped=true"
import script from "./CadastrarCurso.vue?vue&type=script&lang=js"
export * from "./CadastrarCurso.vue?vue&type=script&lang=js"

import "./CadastrarCurso.vue?vue&type=style&index=0&id=5c84f97e&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c84f97e"]])

export default __exports__